import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AbstractService } from './abstract-service.service';
import { HttpClient } from '@angular/common/http';
import { ACTIVE } from '../constants/statusConstant';
import { CLIENTID } from '../constants/queryParamConstants';

@Injectable({
    providedIn: 'root',
})
export class NavigationService extends AbstractService {
    path = '/navigation';

    constructor(
        private router: Router,
        protected httpClient: HttpClient,
    ) {
        super(httpClient);
    }

    Route(route: string, params?: Map<string, string>): void {
        if (route == 'admin' || route == 'role') {
            void this.router.navigate([route], {
                queryParams: {
                    count: 10,
                    offset: 0,
                    status: ACTIVE.toLowerCase(),
                },
            });
        } else if (route == 'projects') {
            if (params != null) {
                if (params.has(CLIENTID)) {
                    void this.router.navigate([route], {
                        queryParams: { clientId: params.get(CLIENTID) },
                    });
                }
            } else {
                void this.router.navigate([route]);
            }
        } else {
            void this.router.navigate([route]);
        }
    }
}
